import React from "react";
import { Box, Heading, Link, VStack, SimpleGrid } from "@chakra-ui/react";
import AppLayout from "../components/layout/AppLayout";
import PageHeader from "../components/PageHeader";

const SubmissionDirectory = () => {
  return (
    <AppLayout>
      <Box p={6}>
        <PageHeader
          title="Submission Directory"
          subtitle="Find retailer & distributor submission portals in one place."
        />

        {/* Two-column responsive layout */}
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacingX={12} spacingY={8} alignItems="start">
          {/* LEFT COLUMN */}
          <Box>
            {/* Club Retailers */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Club Retailers</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://www.rangeme.com/bjs" isExternal>BJs (via RangeMe)</Link>
                <Link href="https://www.costco.com/vendor-inquiries.html" isExternal>Costco</Link>
                <Link href="https://corporate.walmart.com/about/samsclub/sams-club-suppliers" isExternal>Sams Club</Link>
              </VStack>
            </Box>

            {/* C-Store Retailers */}
            <Box mb={6}>
              <Heading size="md" mb={2}>C-Store Retailers</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://www.rangeme.com/7-eleven" isExternal>7-Eleven (via RangeMe)</Link>
                <Link href="https://buc-ees.com/new-vendors/" isExternal>Buc-ees</Link>
                <Link href="https://www.kwiktrip.com/vendors#:~:text=If%20interested%20in%20becoming%20a,to%20vendors%40kwiktrip.com." isExternal>Kwik Trip</Link>
                <Link href="https://www.rangeme.com/wawa" isExternal>Wawa (via RangeMe)</Link>
              </VStack>
            </Box>

            {/* Dollar Retailers */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Dollar Retailers</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://www.rangeme.com/dollargeneral" isExternal>Dollar General (via RangeMe)</Link>
                <Link href="https://corporate.dollartree.com/vendor-real-estate-partners/merchandise-vendors/dollar-tree-new-vendor-application" isExternal>Dollar Tree (via RangeMe)</Link>
              </VStack>
            </Box>

            {/* Drug Retailers */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Drug Retailers</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://www.rangeme.com/cvs" isExternal>CVS (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/riteaid" isExternal>RiteAid (via RangeMe)</Link>
                <Link href="https://webapp.walgreens.com/VendorPortalStellent/prodpublisher/new_vendor/welcome_prospective_walgreen_company_vendor/welcome.htm" isExternal>Walgreens</Link>
              </VStack>
            </Box>

            {/* Grocery Retailers */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Grocery Retailers</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://www.rangeme.com/aholddelhaizeusbrands" isExternal>Ahold Delhaize (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/albertsons" isExternal>Albertsons (via RangeMe)</Link>
                <Link href="https://forms.office.com/pages/responsepage.aspx?id=wtkBFqzHKUGt0ZJm6mAGPOH9N0drf3tInMrFwciwHsZUQ0FRT0UzMlpDTDZBOTFGRTY2VUk2Rjg0ViQlQCN0PWcu" isExternal>Aldi</Link>
                <Link href="https://www.rangeme.com/bigy" isExternal>Big Y (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/brookshires" isExternal>Brookshire's (via RangeMe)</Link>
                <Link href="https://www.brookshirebrothers.com/vendors" isExternal>Brookshire Brothers</Link>
                <Link href="https://www.rangeme.com/coborns" isExternal>Coborn's (via RangeMe)</Link>
                <Link href="https://www.dierbergs.com/pages/new-vendors-suppliers-and-tax-exempt?srsltid=AfmBOoowiTt1Ju98Dt8JHjldY-zJiIqAGGRDezuHwQPAyOiqB-nieaPR" isExternal>Dierbergs</Link>
                <Link href="https://www.rangeme.com/fareway" isExternal>Fareway (via RangeMe)</Link>
                <Link href="https://help.festfoods.com/hc/en-us/requests/new?ticket_form_id=18110610006676" isExternal>FestivalFoods</Link>
                <Link href="https://www.foodcityep.com/faqs" isExternal>Food City (KVAT)</Link>
                <Link href="https://www.rangeme.com/gianteagle" isExternal>Giant Eagle (via RangeMe)</Link>
                <Link href="https://www.harpsfood.com/localpartners" isExternal>Harps</Link>
                <Link href="https://supplier.heb.com/apply-v2/supplier-type" isExternal>HEB</Link>
                <Link href="https://www.heinens.com/new-vendor-requests/" isExternal>Heinen's</Link>
                <Link href="https://www.rangeme.com/hyvee" isExternal>Hy-Vee (via RangeMe)</Link>
                <Link href="https://suppliers.kroger.com/OA_HTML/OA.jsp?page=/oracle/apps/pos/onboard/webui/ProspRegPG&OAHP=POS_GUEST_REG_HP&OASF=POS_SUPPREG_REGISTER&OAPB=POS_ISP_BRAND&ouid=8DBC59F63887C2A6" isExternal>Kroger Vendor Sign-up</Link>
                <Link href="https://www.rangeme.com/lowesfoods" isExternal>Lowes Foods (via RangeMe)</Link>
                <Link href="https://vendornet.meijer.com/ProspectiveVendor/Section/ProspectiveVendor-368" isExternal>Meijer</Link>
                <Link href="https://corporate.publix.com/business/publix-business-connection/retail-product-supplier" isExternal>Publix</Link>
                <Link href="https://www.pigglywiggly.com/contact-us/" isExternal>Piggly Wiggly</Link>
                <Link href="https://www.raleys.com/vendors/prospective-vendors" isExternal>Raleys</Link>
                <Link href="https://www.rouses.com/become-local-vendor/" isExternal>Rouses Markets</Link>
                <Link href="https://www.rangeme.com/save-a-lot" isExternal>Save A Lot (via RangeMe)</Link>
                <Link href="https://www.thesavemartcompanies.com/become-a-supplier" isExternal>Save Mart</Link>
                <Link href="https://www.rangeme.com/schnucks" isExternal>Schnucks (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/smartandfinal" isExternal>Smart & Final (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/winn-dixie" isExternal>Southeastern Grocers (via RangeMe)</Link>
                <Link href="https://www.spartannash.com/wholesale/vendor/#:~:text=Let%20us%20know%20if%20you,you%20as%20soon%20as%20possible." isExternal>SpartanNash</Link>
                <Link href="https://www.rangeme.com/staterbros" isExternal>Stater Bros (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/tops" isExternal>Tops (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/wakefern" isExternal>Wakefern (Shoprite) (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/walgreens" isExternal>Walgreens (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/wegmans" isExternal>Wegmans (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/weismarkets" isExternal>Weis Markets (via RangeMe)</Link>
              </VStack>
            </Box>
          </Box>

          {/* RIGHT COLUMN */}
          <Box>
            {/* Mass Retailers */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Mass Retailers</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://corporate.target.com/sustainability-governance/responsible-supply-chains/suppliers/supplier-intake-form" isExternal>Target</Link>
                <Link href="https://corporate.walmart.com/suppliers/apply-to-be-a-supplier" isExternal>Walmart</Link>
              </VStack>
            </Box>

            {/* Natural Retailers */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Natural Retailers</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://erewhon.formstack.com/forms/vendor_portal_brand" isExternal>Erewhon</Link>
                <Link href="https://www.rangeme.com/freshthyme" isExternal>Fresh Thyme</Link>
                <Link href="https://www.fruitfulyield.com/contacts/" isExternal>Fruitful Yield</Link>
                <Link href="https://www.gelsons.com/new-suppliers" isExternal>Gelsons</Link>
                <Link href="https://forms.office.com/pages/responsepage.aspx?id=xgauneTbBkKgtHM8TWv0QcAUr1YPu5hOkK4_aiesLh9UNVdEUTZSMTk4S0dFNFNVUlkyTlY1R1k1ViQlQCN0PWcu&route=shorturl" isExternal>INFRA Vendor Inquiry</Link>
                <Link href="https://palmdesert.jensensfoods.com/contact/" isExternal>Jensen's</Link>
                <Link href="https://molliestones.com/vendor/" isExternal>Mollie Stone's</Link>
                <Link href="https://pc-dev-upgrade.itx.bz/login" isExternal>NCG Partner Portal</Link>
                <Link href="https://www.naturalgrocers.com/food-product-submissions" isExternal>Natural Grocers</Link>
                <Link href="https://www.oliversmarket.com/contact-us/" isExternal>Oliver's Market</Link>
                <Link href="https://www.plummarket.com/vendor-resources/new-vendor-application/" isExternal>Plum Market</Link>
                <Link href="https://www.roths.com/vendor/" isExternal>Roth's</Link>
                <Link href="https://about.sprouts.com/new-item-submission/" isExternal>Sprouts (Main)</Link>
                <Link href="https://about.sprouts.com/nip/?department=dairy" isExternal>Sprouts - Dairy</Link>
                <Link href="https://about.sprouts.com/nip/?department=frozen" isExternal>Sprouts - Frozen</Link>
                <Link href="https://about.sprouts.com/nip/?department=grocery" isExternal>Sprouts - Grocery</Link>
                <Link href="https://www.streetsmarket.com/vendors" isExternal>Streets Market</Link>
                <Link href="https://sunsetfoods.com/contact-us/" isExternal>Sunset Foods</Link>
                <Link href="https://www.rangeme.com/thefreshmarket" isExternal>The Fresh Market (via RangeMe)</Link>
                <Link href="https://tcmarkets.com/tc-markets-produce-vendor-form/" isExternal>Town & Country</Link>
                <Link href="https://westbornmarket.com/contact-us" isExternal>Westborn Market</Link>
                <Link href="https://grocerycentral.amazon.com" isExternal>Whole Foods / Amazon Vendor Portal</Link>
                <Link href="https://www.zupans.com/app/uploads/2023/08/ZM_NewItemSubmission_2023.pdf" isExternal>Zupan's</Link>
              </VStack>
            </Box>

            {/* Distributors */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Distributors</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://www.gfifoods.com/become-a-supplier" isExternal>GFI (Gourmet Foods Intl)</Link>
                <Link href="https://www.rangeme.com/gopuff" isExternal>GoPuff (via RangeMe)</Link>
                <Link href="https://www.rangeme.com/kehe" isExternal>KeHE (via RangeMe)</Link>
                <Link href="https://www.unfi.com/suppliers/supplier-inquiry.html" isExternal>UNFI</Link>
              </VStack>
            </Box>

            {/* Foodservice Distributors */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Foodservice Distributors</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://www.benekeith.com/contact" isExternal>Ben E. Keith</Link>
                <Link href="https://www.rangeme.com/gordonfoodservice" isExternal>Gordon Foodservice (via RangeMe)</Link>
                <Link href="https://otgnewyork.com/pages/vendor-account-application?srsltid=AfmBOoo59JXKROYhJJuYkufZJdZA6Wfr-6jxoOs23K7xrXXizDxrI-1z" isExternal>OTG (Cibo / Airports)</Link>
                <Link href="https://www.pfgc.com/Connect/Supplier" isExternal>PFG (Performance Food Group)</Link>
                <Link href="https://www.shamrockfoods.com/contact/" isExternal>Shamrock Foods</Link>
                <Link href="https://www.sysco.com/suppliers/supplier-partnerships/supplier-resources" isExternal>Sysco</Link>
                <Link href="https://www.usfoods.com/supplier-info.html" isExternal>US Foods</Link>
              </VStack>
            </Box>

            {/* DSDs */}
            <Box mb={6}>
              <Heading size="md" mb={2}>DSDs</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://www.bcsroyal.com/contact-us" isExternal>BCS Royal</Link>
                <Link href="https://www.biggeyser.com/contact/?type=Supplier" isExternal>Big Geyser</Link>
                <Link href="https://www.dorasnaturals.com/#about" isExternal>Dora's Naturals</Link>
                <Link href="https://www.gothamdsd.com/contact-us/" isExternal>Gotham</Link>
                <Link href="https://www.rainforestdistribution.com/suppliers/new-account/" isExternal>Rainforest Distribution</Link>
              </VStack>
            </Box>

            {/* Brokers */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Brokers</Heading>
              <VStack align="start" spacing={2}>
                <Link href="https://www.acosta.com/contact/business-inquiries/" isExternal>Acosta</Link>
                <Link href="https://youradv.com/contact/" isExternal>Advantage Solutions</Link>
                <Link href="https://joh.com/contact/" isExternal>JOH</Link>
                <Link href="https://www.pmidpi.com/broker-services/" isExternal>Presence</Link>
              </VStack>
            </Box>

            {/* Military Accounts */}
            <Box mb={6}>
              <Heading size="md" mb={2}>Military Accounts</Heading>
              <VStack align="start" spacing={2}>
                {/* Example links — add your real URLs */}
                <Link href="https://corp.commissaries.com/our-agency/business-with-deca" isExternal>DeCA (Commissaries)</Link>
                <Link href="https://www.aafes.com/about-exchange/doing-business/" isExternal>AAFES (Army & Air Force Exchange)</Link>
                <Link href="https://www.mymcx.com/for-marines-by-marines/marine-vendor-sign-up" isExternal>MCX (Marine Corps Exchange)</Link>
                <Link href="https://www.rangeme.com/nexcom" isExternal>NEX (via RangeMe)</Link>
              </VStack>
            </Box>
          </Box>
        </SimpleGrid>
      </Box>
    </AppLayout>
  );
};

export default SubmissionDirectory;
